import React from 'react';
import styled from 'styled-components';

import icon from '../../assets/logo/white_text.svg';

const Text = styled.span`
  display: flex;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  margin-top: 4px;
  line-height: 20px;
  margin-left: 0.25em;
`;

const Icon = styled.img`
  height: 30px;
  display: flex;
  object-fit: contain;
`;

const Div = styled.div`
  display: flex;
  margin-bottom: 1em;
  flex-direction: row;
  align-items: center;
`;

function Logo() {
  return (
    <Div>
      <Icon src={icon} />
      <Text>©2021</Text>
    </Div>
  );
}

export default Logo;
